import jsondiffpatch from 'jsondiffpatch/public/build/jsondiffpatch';
import _ from 'lodash';
import {
  hasGrowthBookFeature,
  GrowthBookFeatures,
} from '../../../../../modules/core';

(function () {
  'use strict';

  angular
    .module('doxy.realtime.components.teleconsent.action.share', [])
    .directive('dClickedElement', function () {
      function fullPath(el) {
        var names = [];
        try {
          while (
            el.parentNode &&
            !el.parentNode.hasAttribute('d-clicked-element')
          ) {
            if (el === el.ownerDocument.documentElement) {
              names.unshift(el.tagName);
            } else {
              for (
                var c = 1, e = el;
                e.previousElementSibling;
                e = e.previousElementSibling, c++
              );
              names.unshift(el.tagName + ':nth-child(' + c + ')');
            }

            el = el.parentNode;
          }
        } catch (err) {}

        return names.join(' > ');
      }

      return {
        restrict: 'A',
        scope: {
          innerMediator: '=dInnerMediator',
          me: '=dMe',
        },
        link: function (scope, elem) {
          function select(res) {
            var className = 'js-selected-' + res.num;
            var previous = elem[0].querySelector('.' + className);
            var current = elem[0].querySelector(res.path);
            if (current) current.classList.add(className);
            if (previous) previous.classList.remove(className);
          }

          elem.bind('click', function (e) {
            const element = e.toElement || e.target;
            if (
              ['INPUT', 'BUTTON', 'CANVAS', 'LABEL'].indexOf(
                element.tagName
              ) !== -1
            )
              return true;
            const path = fullPath(element);
            if (!path) return;
            const data = {
              path: path,
              num: scope.me.userId ? 0 : 1,
            };
            scope.innerMediator.emit('click', data);
            select(data, scope.me);
          });

          scope.innerMediator.on('click:get', (message, person) => {
            select(message, person.state);
          });
        },
      };
    })
    .factory('scrollFactory', function ($window, $document) {
      const arrowKeys = new Set([
        'ArrowUp',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
      ]);
      const inputTypes = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

      function preventDefault(e) {
        e = e || $window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      }

      function keydown(e) {
        const isArrowKey = arrowKeys.has(e.key);
        const isInput = inputTypes.has(e.target.tagName);
        const isEditable = e.target.isContentEditable === true;
        if (isArrowKey && !(isInput || isEditable)) {
          preventDefault(e);
        }
      }

      return {
        disableScroll: function () {
          $window.addEventListener(
            'MozMousePixelScroll',
            preventDefault,
            false
          );
          $window.addEventListener('wheel', preventDefault, false);
          // To disable sroll with selection
          $window.addEventListener('selectstart', preventDefault, false);
          //$window.addEventListener('mousedown', preventDefault, false);
          $window.addEventListener('touchmove', preventDefault, {
            passive: false,
          });
          $window.onmousewheel = $document[0].onmousewheel = preventDefault;
          $document[0].onkeydown = keydown;
        },

        enableScroll: function () {
          $window.removeEventListener(
            'MozMousePixelScroll',
            preventDefault,
            false
          );
          $window.removeEventListener('wheel', preventDefault, false);
          $window.removeEventListener('selectstart', preventDefault, false);
          //$window.removeEventListener('mousedown', preventDefault, false);
          $window.removeEventListener('touchmove', preventDefault, {
            passive: false,
          });
          $window.onmousewheel =
            $document[0].onmousewheel =
            $document[0].onkeydown =
              null;
          $document[0].onkeydown = null;
        },
      };
    })
    .directive('dModalScroll', function ($window, scrollFactory) {
      return {
        restrict: 'A',
        scope: {
          innerMediator: '=?dModalScroll',
          me: '=dMe',
        },
        link: function (scope, elem) {
          if (!scope.innerMediator) return;
          function onScrollGet(message) {
            if ('scrollTopPercent' in message) {
              elem.scrollTo(0, message.scrollTopPercent * elem[0].scrollHeight);
              return;
            }

            elem.scrollTo(0, message.scrollTop);
          }

          const onScroll = _.throttle((event) => {
            if (!scope.innerMediator) return;

            if (
              hasGrowthBookFeature(
                GrowthBookFeatures.TeleconsentPercentageScroll
              )
            ) {
              scope.innerMediator.emit('scroll', {
                scrollTopPercent:
                  event.target.scrollTop / event.target.scrollHeight,
              });
              return;
            }

            scope.innerMediator.emit('scroll', {
              scrollTop: event.target.scrollTop,
            });
          }, 100);

          if (scope.me.type === 'p') {
            scrollFactory.disableScroll();
            // Ensure innerMediator is available before setting up event listeners
            if (scope.innerMediator && typeof scope.innerMediator.on === 'function') {
              scope.innerMediator.on('scroll:get', onScrollGet);
              scope.$on('$destroy', () => {
                scrollFactory.enableScroll();
                scope.innerMediator.off('scroll:get', onScrollGet);
              });
            } else {
              console.warn('dModalScroll: innerMediator not available or missing on method');
            }
          } else {
            elem.bind('scroll', onScroll);
          }
        },
      };
    })
    .directive('dCursor', function () {
      return {
        restrict: 'A',
        scope: {
          person: '=dCursor',
          innerMediator: '=dInnerMediator',
        },
        link: function (scope, elem) {
          var listener = function (pos, person) {
            if (person !== scope.person) return;
            elem.css({
              transform: 'translate(' + pos.left + 'px, ' + pos.top + 'px)',
            });
          };

          // Ensure innerMediator is available before setting up event listeners
          if (scope.innerMediator && typeof scope.innerMediator.on === 'function') {
            scope.innerMediator.on('mouse:get', listener);
            scope.$on('$destroy', function () {
              scope.innerMediator.off('mouse:get', listener);
            });
          } else {
            console.warn('dCursor: innerMediator not available or missing on method');
          }
        },
      };
    })
    .directive('dTrackMouse', function () {
      return {
        scope: {
          innerMediator: '=dTrackMouse',
        },
        link: function (scope, elem) {
          var trackMouseMove = _.throttle(function (event) {
            var rect = elem[0].getBoundingClientRect();
            if (scope.innerMediator) {
              scope.innerMediator.emit('mouse', {
                left: event.clientX - rect.left,
                top: event.clientY - rect.top,
              });
            }
          }, 100);

          var bindMouseMove = _.debounce(function () {
            elem.bind('mousemove', trackMouseMove);
          }, 200);

          // Ensure innerMediator is available before setting up event listeners
          if (scope.innerMediator && typeof scope.innerMediator.on === 'function') {
            scope.innerMediator.on('scroll', function () {
              elem.off('mousemove', trackMouseMove);
              bindMouseMove();
            });
          } else {
            console.warn('dTrackMouse: innerMediator not available or missing on method');
          }

          bindMouseMove();
        },
      };
    })
    .directive('dTeleconsentShare', function () {
      return {
        restrict: 'E',
        scope: {
          innerMediator: '=dInnerMediator',
          document: '=dDocument',
          me: '=dMe',
        },
        controller: 'TeleconsentShareController as vm',
        templateUrl:
          '/app/realtime/components/teleconsent/action/share/' +
          'teleconsent.action.share.tpl.html',
        link: function (scope) {
          var receivedDiff;
          var receivedData;

          // Ensure innerMediator is available before setting up event listeners
          if (!scope.innerMediator || typeof scope.innerMediator.on !== 'function') {
            console.warn('dTeleconsentShare: innerMediator not available or missing on method');
            return;
          }

          scope.$watch(
            'document.data',
            function (newVal, oldVal) {
              if (_.isEqual(newVal, receivedData)) return;
              var diff = jsondiffpatch.diff(oldVal, newVal);
              if (!diff || (receivedDiff && angular.equals(diff, receivedDiff)))
                return;
              scope.innerMediator.emit('data', diff);
              scope.vm.setAuditTrial(diff);
            },
            true
          );

          scope.innerMediator.on('data:get', function (dataDiff, person) {
            receivedDiff = dataDiff;
            var oldData = _.cloneDeep(scope.document.data);
            jsondiffpatch.patch(scope.document.data, dataDiff);
            if (_.isEqual(oldData, scope.document.data)) return;
            receivedData = _.cloneDeep(scope.document.data);
            scope.vm.setAuditTrial(dataDiff, person, true);
          });

          scope.innerMediator.on('submit:get', function (res) {
            scope.vm.markSubmit(res.isValid);
          });
        },
      };
    })
    .directive('dAccessibleForm', function () {
      return {
        restrict: 'A',
        link: function (scope, elem) {
          scope.$on('submit:error', function () {
            var firstInvalid = elem[0].querySelector('.ng-invalid');
            if (firstInvalid) firstInvalid.focus();
          });
        },
      };
    });
})();
